import React, { useState, useEffect } from 'react';
import CallToActionButton from '../../../../component/call-to-action-button/call-to-action-button';
import { EditText } from '../../../../component/ui/edit-text/edit-text';
import { duplicatePollOperation } from '../operations/duplicate-poll-operation';
import { PollWithQuestionsResponse } from '../../../../api/types/settings/settings-all';

interface DuplicatePollDialogProps {
  originalPoll: PollWithQuestionsResponse;
  closeDialog: () => void;
}

export const DuplicatePollDialog: React.FC<DuplicatePollDialogProps> = ({
  originalPoll,
  closeDialog,
}) => {
  const [pollName, setPollName] = useState(`${originalPoll.pollName} - העתק`);
  const [loading, setLoading] = useState(false);

  // Update poll name when originalPoll changes
  useEffect(() => {
    setPollName(`${originalPoll.pollName} - העתק`);
  }, [originalPoll]);

  const handleOnSubmit = async () => {
    await duplicatePollOperation(
      originalPoll,
      pollName,
      setLoading,
      closeDialog,
    );
  };

  return (
    <div>
      <EditText
        title={'שם המשוב'}
        onChange={setPollName}
        value={pollName}
        maxLength={100}
      />
      <div style={{ height: '8px' }} />
      <CallToActionButton
        text={'העתקת משוב'}
        onClick={handleOnSubmit}
        loading={loading}
      />
    </div>
  );
};
